import { render, staticRenderFns } from "./CreateTournamentForm.vue?vue&type=template&id=48914292&"
import script from "./CreateTournamentForm.vue?vue&type=script&lang=ts&"
export * from "./CreateTournamentForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VStepper } from 'vuetify/lib/components/VStepper';
installComponents(component, {VForm,VStepper})
